import React from 'react';
import styled from 'styled-components/macro';
import useMenu from '../../../hooks/api/queries/useMenu';
import { useMenuContext } from '../../../hooks/context/useMenuContext';
import { NavLink } from '../nav/NavLink';

type Props = {};

export const MenuNav: React.FC<Props> = () => {
  const { selected, setSelected } = useMenuContext();
  const { data } = useMenu();

  if (!data) return null;
  return (
    <Nav>
      {data.map((item, index) => (
        <NavLink
          label={item.name}
          onClick={() =>
            selected === index ? setSelected(-1) : setSelected(index)
          }
          key={`nav-${index}`}
          active={selected === index}
          hasSubMenu={item.children !== undefined}
          slug={item.slug}
        />
      ))}
    </Nav>
  );
};

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;

  > * {
    cursor: pointer;
  }
`;
